import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getTransfer } from "../../../../utils/services/transfer";
// componentes
import TableTransfer from "../../Transfer/tableTransfer";
import ModalNewTransfer from "../../Transfer/ModalNewTransfer";
import ActionButtonRounded from "../../../../components/Buttons/ActionButtonRounded";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

export default function Tranfers(props) {
  const { idEvent, participants, user } = props;
  const location = useLocation();
  const [transfer, setTransfer] = useState([]);
  // modal
  const [modalNewTransfer, setModalNewTransfer] = useState(false);
  // loading
  const [loading, setLoading] = useState(false);

  function checkProductExists(product) {
    if (location.state) {
      const search = location.state.event.product.filter(
        (e) => e.name === product
      );

      if (search[0]) {
        return true;
      } else return false;
    }
  }

  function getData() {
    setLoading(true);
    getTransfer({
      idEvent: idEvent,
      limit: 100,
      offset: 1,
      search: user.id,
      columnSearch: "id",
      hasGestaoClick: checkProductExists("Inteegra MOBI")
        ? "true"
        : "false",
    })
      .then((res) => {
        if (
          res.message === "TRANSFERS_BY_EVENT" &&
          res.findOneTransferData.count > 0
        ) {
          setTransfer(res.findOneTransferData.data);
        } else setTransfer([]);
      })
      .catch(() => {
        toast.error("Erro ao carregar transfers.");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (user?.id) {
      getData();
    }
  }, [user.id]);

  return (
    <>
      {modalNewTransfer && (
        <ModalNewTransfer
          isOpen={modalNewTransfer}
          toggle={() => setModalNewTransfer(false)}
          idEvent={idEvent}
          data={getData}
          user={user}
          transfer={transfer}
        />
      )}

      <div className="my-3">
        <div className="d-flex justify-content-end">
          <ActionButtonRounded
            title="Adicionar Transfer"
            onClick={() => setModalNewTransfer(true)}
            className="btn-rounded waves-effect waves-light events-button-add mb-2"
          />
        </div>

        {loading ? (
          <LoadingSkelentonTable lines={5} cols={4} />
        ) : (
          <TableTransfer
            transfer={transfer}
            idEvent={idEvent}
            data={getData}
            participants={participants}
          />
        )}
      </div>
    </>
  );
}
